/**
 *
 * MRATag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import ProductivityIcon from 'assets/v2/ProductivityIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.orchidDark};
    background: ${COLORS.orchidLight};
    border-color: ${COLORS.orchid};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.orchid};
    }
  }
`;

function MRATag(props) {
  return <StyledTag label="MRA" icon={<ProductivityIcon />} {...props} />;
}

export default memo(MRATag);
